/**
 * @generated SignedSource<<507d9770a05b3dcf54be0d39aded2064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionFollowupSections_routine$data = {
  readonly activeSections: ReadonlyArray<{
    readonly assignedTeam: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly lastVersion: {
      readonly id: string;
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly sentiments?: ReadonlyArray<TaskSentiment>;
        readonly title: string;
        readonly unit?: NumberTaskUnit;
      }>;
      readonly title: string | null;
    };
  }>;
  readonly " $fragmentType": "RoutineOccasionFollowupSections_routine";
};
export type RoutineOccasionFollowupSections_routine$key = {
  readonly " $data"?: RoutineOccasionFollowupSections_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupSections_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "endAt"
    },
    {
      "kind": "RootArgument",
      "name": "startAt"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionFollowupSections_routine",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "endAt",
          "variableName": "endAt"
        },
        {
          "kind": "Variable",
          "name": "startAt",
          "variableName": "startAt"
        }
      ],
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "activeSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "lastVersion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unit",
                      "storageKey": null
                    }
                  ],
                  "type": "TaskNumber",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sentiments",
                      "storageKey": null
                    }
                  ],
                  "type": "TaskCheck",
                  "abstractKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "67b2565356c37ab6d620a29e2289fae2";

export default node;
